<!-- 主页 -->
<template>
  <div class=''>
    <TopNav :items="navData"
            @itemClick="navItemClick"></TopNav>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav/TopNav.vue'
export default {
  name: 'IndexPage',
  components: {
    TopNav
  },
  data () {
    return {
      navData: [
        { id: 1, title: '首页', type: 'sy', route: 'home' },
        { id: 2, title: '服务中心', type: 'fwzx', route: 'service' },
        { id: 3, title: '驱动下载', type: 'qdxz', route: 'actuate' },
        { id: 4, title: '关于我们', type: 'gywm', route: 'about' }
      ]

    }
  },
  computed: {},
  watch: {},
  // 方法集合
  methods: {
    navItemClick ({ index, item }) {
      // console.log(item)
      if (this.$route.name !== item.route) {
        this.$router.replace({ name: item.route, params: { item: 'companyIntroduce' } }, () => { })
      }
    }
  },
  created () {

  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
</style>
